<template>
  <div class="monthView-container">
    <div class="month-name-container">
      <v-row>
        <v-col cols="3"
          ><v-btn
            aria-label="Previous Month"
            class="btn-cal"
            :disabled="isMinMonth"
            @click="onPreviousMonth"
            ><v-icon v-show="!isMinMonth">mdi-arrow-left</v-icon></v-btn
          ></v-col
        >
        <v-col cols="6">
          <div
            class="month-name public-h6"
            role="alert"
            aria-live="assertive"
            :aria-label="months[month] + ' ' + year"
          >
            {{ months[month] }} {{ year }}
          </div>
        </v-col>
        <v-col cols="3"
          ><v-btn
            aria-label="Next Month"
            class="btn-cal"
            :disabled="isMaxMonth"
            @click="onNextMonth"
            ><v-icon v-show="!isMaxMonth">mdi-arrow-right</v-icon></v-btn
          ></v-col
        >
      </v-row>
    </div>
    <div class="body-container">
      <div class="dayNames-container">
        <v-card
          v-for="(dayName, index) in dayNames"
          :aria-label="fullDayNames[index]"
          role="presentation"
          :class="['dayName', dayName]"
          :key="
            year +
            '-' +
            months[month] +
            '-' +
            dayName +
            Math.random().toString(9).slice(2, 7)
          "
        >
          <span aria-hidden="true">{{ dayName }}</span>
        </v-card>
      </div>
      <div class="dates-container">
        <v-card
          @click="onDateChanged(date)"
          @keydown.enter="onDateChanged(date)"
          @keydown.space="onDateChanged(date)"
          :disabled="!date.isAvailable"
          role="button"
          title
          v-for="date in dates"
          :id="date.date"
          :key="date.date"
          :aria-label="date.ariaDate"
          :aria-pressed="isDateSelected(date)"
          :class="[
            'date',
            dayNames[date.day],
            isDateSelected(date) ? 'selected-date' : '',
          ]"
          :style="`grid-area: ${
            date.date > firstSatDate
              ? Math.ceil((date.date - firstSatDate) / 7) + 1
              : 1
          }/${date.day + 1}/span 1/span 1`"
        >
          <span aria-hidden="true">{{ date.date }}</span></v-card
        >
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
const keys = { up: 38, down: 40, left: 37, right: 39 };
export default {
  props: ["minDate", "maxDate", "availableDates", "locale"],
  data() {
    return {
      months: [
        "JANUARY",
        "FEBRUARY",
        "MARCH",
        "APRIL",
        "MAY",
        "JUNE",
        "JULY",
        "AUGUST",
        "SEPTEMBER",
        "OCTOBER",
        "NOVEMBER",
        "DECEMBER",
      ],
      dayNames: ["S", "M", "T", "W", "T", "F", "S"],
      fullDayNames: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      dates: [],
      firstSatDate: "",
      month: 0,
      year: 0,
      selectedDate: {},
    };
  },
  computed: {
    isMinMonth() {
      return this.minDate.month - 1 === this.month;
    },
    isMaxMonth() {
      return this.maxDate && this.maxDate.month - 1 === this.month;
    },
  },
  methods: {
    getDates: function (yr, mth) {
      this.dates = []; //resets the 'dates' property to an empty array.
      var d = new Date(yr, mth, 1, 2);
      if (!!d.getTime() && mth <= 11 && mth >= 0) {
        //to handle errors if arguments are not valid.
        while (d.getMonth() == mth) {
          let date = {
            date: d.getDate(),
            day: d.getDay(),
            month: mth + 1,
            year: yr,
            isSelected: false,
            isAvailable: false,
            ariaDate: this.getAriaDate(d),
          };
          date.isAvailable = this.isAvailableDate(date);
          //Make sure date isn't already in the list//
          if (
            !this.dates.find((e) => e.date == d.getDate() && e.month == mth + 1)
          ) {
            this.dates.push(date);
          }
          d = new Date(d.getTime() + 1000 * 60 * 60 * 24);
        }
        this.firstSatDate = 7 - this.dates[0].day; //compute the date of the first Saturday of the given month
      } else {
        this.dates.push({}); //push an empty object into the 'dates' array
      }
    },
    isMinDate(date) {
      console.log("SelectedDate", this.selectedDate);
      return date.date === this.minDate.date;
    },
    onNextMonth() {
      this.updateMonth(++this.month);
    },
    onPreviousMonth() {
      this.updateMonth(--this.month);
    },
    updateMonth(newMonth) {
      this.month = newMonth;
      if (newMonth > 11) {
        this.month = 0;
        this.year++;
      }

      if (newMonth < 0) {
        this.month = 11;
        this.year--;
      }
      console.log("year", this.year, "month", this.month);
      this.getDates(this.year, this.month);
      const m = (newMonth + 1).toString().padStart(2, "0");
      this.$emit("monthChanged", `${this.year}-${m}`);
    },
    onDateChanged(date) {
      this.selectedDate = date;
      this.$emit("dateChanged", { ...date, fullDate: this.getFullDate(date) });
    },
    isDateSelected(date) {
      return (
        this.selectedDate.date === date.date &&
        this.selectedDate.month === date.month &&
        this.selectedDate.year === date.year
      );
    },
    getDayNames(locale = "en", format = "long") {
      const formatter = new Intl.DateTimeFormat(locale, {
        weekday: format === "single" ? "short" : format,
        timeZone: "UTC",
      });
      const days = [1, 2, 3, 4, 5, 6, 7].map((day) => {
        const dd = day < 10 ? `0${day}` : day;
        return new Date(`2017-01-${dd}T00:00:00+00:00`);
      });
      return days.map((date) => {
        let day = formatter.format(date);
        if (format === "single") {
          return day[0];
        }
        return day.toUpperCase();
      });
    },
    getMonthNames(locale = "en", format = "long") {
      const formatter = new Intl.DateTimeFormat(locale, {
        month: format,
        timeZone: "UTC",
      });
      const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month) => {
        const mm = month < 10 ? `0${month}` : month;
        return new Date(`2017-${mm}-01T00:00:00+00:00`);
      });
      return months.map((date) => formatter.format(date));
    },
    isAvailableDate(date) {
      return (
        this.availableDates &&
        this.availableDates.find((d) => {
          return (
            d.year == date.year && d.month == date.month && d.date === date.date
          );
        })
      );
    },
    getFullDate(date) {
      let fullDate = new Date(date.year, date.month - 1, date.date);
      fullDate.setUTCHours(0, 0, 0);
      return fullDate.toISOString().split(".")[0];
    },
    getAriaDate(date) {
      return this.localeFormattedDate(date);
    },
    localeFormattedDate(date) {
      const day = date.toLocaleDateString(this.language, {
        weekday: "long",
      });
      const month = date.toLocaleDateString(this.language, {
        month: "long",
      });
      const d = date.getDate();
      const year = date.getFullYear();
      return `${day} ${month} ${d}, ${year}`;
    },
    handleKeyDown(e) {
      var code = e.which || e.keyCode;
      // number of items across
      var width = 7;
      var increment; //, index, newIndex, active;
      console.log(e);
      switch (code) {
        case keys.up:
          increment = -width;
          break;
        case keys.down:
          increment = width;
          break;
        case keys.left:
          increment = -1;
          break;
        case keys.right:
          increment = 1;
          break;
        default:
          increment = 0;
          break;
      }

      if (increment !== 0) {
        e.preventDefault();

        if (increment > 0) {
          console.log("next");
          console.log(e.target.nextSibling);
          e.target.nextSibling && e.target.nextSibling.focus();
        } else {
          console.log("previous");
          console.log(e.target.previousSibling);
          e.target.previousSibling && e.target.previousSibling.focus();
        }
      }
    },
  },
  created() {
    //called when the component is created.

    if (this.minDate) {
      this.year = this.minDate.year;
      this.month = this.minDate.month - 1;
    }
    this.getDates(this.year, this.month);
    this.dayNames = this.getDayNames(this.locale, "single");
    this.fullDayNames = this.getDayNames(this.locale);
    this.months = this.getMonthNames(this.locale, "long");
    //this.onDateChanged(this.minDate);
  },
  watch: {
    availableDates: function () {
      this.getDates(this.year, this.month);
    },
    minDate: function () {
      //this.selectedDate = this.minDate;
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  vertical-align: baseline;
}

div.monthView-container {
  display: inline-grid;
  grid-template-columns: 1fr;
  font-size: 14px;
  letter-spacing: 0.05em;
}

.monthView-container div.month-name-container {
  background: #0b5583;
  color: #fff;
  line-height: 1em;
  padding: 8px;
  text-align: center;
  border: solid 1px #000;
}

.monthView-container .btn-cal {
  color: white !important;
  background-color: transparent !important;
  height: 100% !important;
  width: 100% !important;
  border: none;
  box-shadow: none;
}

.monthView-container .btn-cal:focus {
  border: solid #fff 0.15em !important;
}

.monthView-container .btn-cal:hover {
  opacity: 0.7 !important;
}

.monthView-container .btn-cal:hover::before,
.monthView-container .btn-cal:focus::before {
  background-color: transparent !important;
  color: transparent !important;
}

.monthView-container .btn-cal.v-btn--disabled {
  color: white !important;
  background-color: transparent !important;
  opacity: 50;
}

.monthView-container .btn-cal.v-btn--disabled .v-icon {
  color: gray !important;
}

div.body-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2px;
}

div.dayNames-container {
  display: grid;
  grid-template-columns: repeat(7, auto);
  grid-gap: 2px;
  margin-top: 2px;
  font-weight: bold !important;
}

div.dates-container {
  display: grid;
  grid-template-columns: repeat(7, auto);
  grid-gap: 2px;
  font-weight: bold;
}

div.dayName,
div.date {
  width: 4em;
  padding: 10px;
  border-radius: 1px !important;
}

div.selected-date {
  background: #0b5583 !important;
  color: white !important;
  border-color: #fff;
}

div.min-date {
  border: solid #000 0.15em !important;
}

div.date:hover:not(div.SUN):not(div.SAT) {
  border: solid #0b5583 0.25em;
  opacity: 0.7 !important;
}

div.date:focus:not(div.SUN):not(div.SAT) {
  border: solid #0b5583 0.25em !important;
}

div.selected-date:focus:not(div.SUN):not(div.SAT) {
  border: solid #fff 2px !important;
}

div.dayName {
  text-align: center;
  line-height: 1em;
  background: #0b5583;
  border: solid 1px #000;
  color: #fff;
}

div.date {
  text-align: right;
  background: #fff;
  color: black;
  font-weight: 600;
  height: 3em;
  cursor: pointer;
  border: solid 1px #000;
}

div.date.v-card--disabled {
  color: rgba(0, 0, 0, 0.26) !important;
  opacity: 0.6;
  color: grey !important;
}

div.SAT.dayName,
div.SUN.dayName {
  background: #0b5583;
  border: solid 1px #000;
  color: #fff;
}

div.SAT,
div.SUN {
  background: #d0d0d0ce;
  color: rgba(0, 0, 0, 0.26);
  cursor: default;
  border: solid 1px #000;
}

@media screen and (max-width: 600px) {
  div.dayName,
  div.date {
    font-size: 12px;
  }
}

@media screen and (max-width: 500px) {
  .month-name.public-h6 {
    font-size: 1rem;
    line-height: 2;
  }

  div.monthView-container {
    font-size: 14px !important;
  }

  div.dayName,
  div.date {
    font-size: 0.95em;
  }

  div.monthView-container .mdi-arrow-left::before,
  .mdi-arrow-right::before {
    transform: scale(0.75);
  }

  div.dayName,
  div.date {
    width: 3.5em;
    padding: 4px;
    padding-top: 8px;
    height: 2.5em;
  }
}

@media screen and (max-width: 400px) {
  div.monthView-container {
    font-size: 12px !important;
  }

  div.dayName,
  div.date {
    width: 3em;
    padding: 2px;
    padding-top: 4px;
    height: 2em;
  }

  .month-name.public-h6 {
    font-size: 4vw;
    line-height: 2;
  }
}

@media screen and (max-width: 350px) {
  div.monthView-container {
    margin-left: -15px;
  }
}
</style>
